import { useCallback, useEffect, useRef, useState } from 'react'
import ReactECharts from 'echarts-for-react'
import { Splide, SplideSlide } from '@splidejs/react-splide'
import { GrFormNext, GrFormPrevious } from 'react-icons/gr'
import { Link, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { homeFutureMineralsLastMonthPricesOptions } from '../../../config/splide-slide-options'
import axiosClient from '../../../config/axios-client'
import { getPriceChangeValue } from '../../../config/global'
import HomeFutureMineralsPricesChange from './HomeFutureMineralsPricesChange'
import moment from 'moment'
import HomeFutureLastMonthPricesSlider from './HomeFutureLastMonthPricesSlider'
import HomeFutureLastMonthPricesSliderLoading from './HomeFutureLastMonthPricesSliderLoading'

export default function HomeFutureLastMonthPricesSection() {
  const { lng } = useParams()
  const { t } = useTranslation()
  const futureMineralsLastMonthPricesSliderRef = useRef(null)
  const chartRefs = useRef([]) // Create array of refs for multiple charts

  const [minerals, setMinerals] = useState(null)
  const [isLoading, setIsLoading] = useState(true)

  const handleNavigation = useCallback(
    (direction) => {
      const adjustment = lng === 'en' ? (direction === 1 ? '+1' : '-1') : direction === 1 ? '-1' : '+1'
      futureMineralsLastMonthPricesSliderRef.current.splide.go(adjustment)
    },
    [lng],
  )

  const getFutureMineralsPricesHome = useCallback(() => {
    axiosClient
      .get('/platform/minerals/prices/home')
      .then(({ data }) => {
        setMinerals(data.minerals)
      })
      .catch((error) => {})
      .finally(() => {
        setIsLoading(false)
      })
  }, [])

  // Resize the charts when the slides change
  useEffect(() => {
    getFutureMineralsPricesHome()
  }, [getFutureMineralsPricesHome])

  return (
    <div className="app-container px-8 py-16 lg:px-0">
      <div className="flex flex-col gap-4">
        <div
          data-aos="fade-down"
          className="flex flex-col justify-between gap-2 md:flex-row md:items-center md:gap-2"
        >
          <h2 className="text-2xl font-black">{t('MINERALS_PRICES')}</h2>
          <div className="flex items-center justify-end gap-2">
            <button
              onClick={() => handleNavigation(1)}
              aria-label={t('NEXT')}
              className="flex items-center border-2 border-muted-300 bg-white p-2 hover:border-secondary-600 hover:bg-light ltr:rotate-180"
            >
              <GrFormNext className="h-5 w-5" />
            </button>
            <button
              onClick={() => handleNavigation(-1)}
              aria-label={t('PREVIOUS')}
              className="flex items-center border-2 border-muted-300 bg-white p-2 hover:border-secondary-600 hover:bg-light ltr:rotate-180"
            >
              <GrFormPrevious className="h-5 w-5" />
            </button>
            <Link
              title={t('MORE')}
              to={`/${lng}/minerals/alalmnyom-aluminium/prices?CHART=AREA&INTERVAL=MONTH`}
              className="flex select-none items-center border-2 border-muted-300 bg-white px-3 py-1.5 hover:border-secondary-600 hover:bg-light"
            >
              {t('MORE')}
            </Link>
          </div>
        </div>
        <div data-aos="fade-up">
          {isLoading ? (
            <HomeFutureLastMonthPricesSliderLoading />
          ) : (
            <HomeFutureLastMonthPricesSlider
              minerals={minerals}
              lng={lng}
              futureMineralsLastMonthPricesSliderRef={futureMineralsLastMonthPricesSliderRef}
            />
          )}
        </div>
      </div>
    </div>
  )
}
